module.exports = __webpack_public_path__ + "img/eat_out_07.2a6a25a6.jpg";